import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingBottom: 38,
    paddingHorizontal: 20,
    backgroundColor: 'white',
    minWidth: '100%',
  },
  topContainer: {
    marginTop: 35,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    paddingHorizontal: 20,
  },
  filterText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  iconX: {
    display: 'none',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap:10,
    width: '100%',
    marginTop: 20,
  },
  containerFilter: {
    height: 700,
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingVertical: 15,
  },
  spaceHorizontal: {
    paddingHorizontal: 15,
  },
  containerDrop: {
    marginTop: 30,
  },
  containerButton: {
    paddingHorizontal: 20,
    marginBottom: 20,
    gap: 10,
    backgroundColor: 'white',
  },
  containerInput: {
    flexDirection: 'row',
    maxWidth: 'auto',
    alignItems: 'flex-end',
  },
  numberItemContainer: {
    marginBottom: 15,
    color: 'black',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 8,
  },
  textNumber: {
    fontSize: 16,
    color: 'black',
  },
  input: {
    width: '90%',
    color: 'black',
    backgroundColor: Colors.GrayPallete.lightgrayTwo,
    paddingHorizontal: 20,
  },
  addButton: {
    alignSelf: 'center',
    marginLeft: 4,
  },
});
